import { Reorder } from 'framer-motion';
import { X, GripVertical, Star, Loader2 } from 'lucide-react';

export default function ReorderablePhotos({ photos, onReorder, onRemove, getUrl, onAdd, maxPhotos = 6, primaryChecking = false }) {
  return (
    <div data-testid="reorderable-photos">
      {photos.length > 0 ? (
        <Reorder.Group axis="y" values={photos} onReorder={onReorder} className="grid grid-cols-3 gap-2">
          {photos.map((p, i) => (
            <Reorder.Item key={p} value={p} className="relative touch-none cursor-grab active:cursor-grabbing">
              <div className="aspect-square rounded-xl overflow-hidden relative group bg-[var(--surface-2)] border border-[var(--hairline)]" data-testid={`reorder-photo-${i}`}>
                <img src={getUrl(p)} alt="" className="w-full h-full object-cover pointer-events-none" draggable={false} />
                {i === 0 && (
                  <div className="absolute top-1.5 left-1.5 px-1.5 py-0.5 rounded-full bg-[#B38138]/95 flex items-center gap-0.5 pointer-events-none">
                    <Star size={8} className="text-white" fill="currentColor"/>
                    <span className="text-[8px] font-bold text-white uppercase tracking-wider">Main</span>
                  </div>
                )}
                {/* Pre-flight moderation overlay — position 0 only, while /photos/moderate runs. */}
                {i === 0 && primaryChecking && (
                  <div className="absolute inset-0 bg-black/50 backdrop-blur-[2px] flex flex-col items-center justify-center gap-1.5 z-10 pointer-events-none"
                    data-testid="primary-photo-checking">
                    <Loader2 size={16} className="text-white animate-spin" />
                    <span className="text-[10px] text-white font-semibold uppercase tracking-wider">Checking&hellip;</span>
                  </div>
                )}
                <div className="absolute top-1.5 right-1.5 w-5 h-5 rounded-full bg-black/40 backdrop-blur flex items-center justify-center pointer-events-none">
                  <GripVertical size={11} className="text-white/80" />
                </div>
                <button onClick={(e) => { e.stopPropagation(); onRemove(p); }} data-testid={`remove-photo-${i}`}
                  className="absolute bottom-1.5 right-1.5 w-6 h-6 rounded-full bg-white/95 flex items-center justify-center shadow-md hover:bg-white">
                  <X size={11} className="text-[#0F0F10]" strokeWidth={2.5}/>
                </button>
              </div>
            </Reorder.Item>
          ))}
        </Reorder.Group>
      ) : null}
      {photos.length < maxPhotos && (
        <div className={photos.length > 0 ? "grid grid-cols-3 gap-2 mt-2" : "grid grid-cols-3 gap-2"}>
          {onAdd}
        </div>
      )}
      {photos.length > 1 && (
        <p className="text-[10px] text-[#8A8A93] mt-2 text-center">Drag to reorder &middot; First photo is your main</p>
      )}
    </div>
  );
}
